import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Plus } from "lucide-react";

function RenderAddCreditModal(props) {
  const handleClose = () => {
    props.setShow(false);
  };

  const handleCreditChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      props.setCreditsValue(value);
      return;
    }

    // Regex: numbers with optional decimal up to 2 places
    const regex = /^\d+(\.\d{0,2})?$/;

    if (regex.test(value)) {
      props.setCreditsValue(value);
    }
  };

  return (
    <>
      <style>
        {`
          .add-credit-modal .modal-dialog {
            max-width: 420px !important;
          }
          .add-credit-modal .modal-content {
            border-radius: 14px !important;
            overflow: hidden;
            box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
          }
          .add-credit-modal .modal-header {
            background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
            color: white !important;
            border-bottom: none !important;
            border-radius: 14px 14px 0 0 !important;
            padding: 18px 24px !important;
          }
          .add-credit-modal .modal-title {
            color: white !important;
            font-size: 20px !important;
            font-weight: 600 !important;
            letter-spacing: 0.3px !important;
            margin: 0 !important;
          }
          .add-credit-modal .btn-close {
            filter: brightness(0) invert(1) !important;
            opacity: 0.8 !important;
            font-size: 20px !important;
            transition: opacity 0.2s !important;
          }
          .add-credit-modal .btn-close:hover {
            opacity: 1 !important;
          }
          .add-credit-modal .modal-body {
            padding: 24px !important;
          }
        `}
      </style>
      <Modal 
        show={props.show} 
        onHide={handleClose} 
        centered
        dialogClassName="add-credit-modal"
      >
        <Modal.Header>
          <Modal.Title>{props?.title ? props?.title : "Add Voice Credits"}</Modal.Title>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={handleClose}
            aria-label="Close"
          />
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="creditValue">
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <div style={{
                  backgroundColor: "#f3f4f6",
                  border: "1px solid #e5e7eb",
                  borderRight: "none",
                  borderRadius: "8px 0 0 8px",
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#6b7280",
                  minWidth: "45px"
                }}>
                  $
                </div>
                <Form.Control
                  type="number"
                  value={props.creditsValue}
                  onChange={handleCreditChange}
                  placeholder="0"
                  min="0"
                  step="0.01"
                  style={{
                    borderRadius: "0",
                    borderLeft: "none",
                    borderRight: "none",
                    backgroundColor: "#f9fafb",
                    padding: "8px 12px",
                    fontSize: "16px"
                  }}
                />
                <button
                  type="button"
                  onClick={() => {
                    const currentValue = parseFloat(props.creditsValue) || 0;
                    props.setCreditsValue((currentValue + 1).toString());
                  }}
                  style={{
                    backgroundColor: "#4f6edb",
                    border: "none",
                    borderRadius: "0 8px 8px 0",
                    padding: "8px 12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "white",
                    minWidth: "45px",
                    transition: "background-color 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#3b5ccc";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#4f6edb";
                  }}
                >
                  <Plus size={20} />
                </button>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <div style={{
          backgroundColor: "white",
          borderTop: "1px solid #e5e7eb",
          padding: "16px 24px",
          marginTop: "0",
          borderRadius: "0 0 14px 14px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px"
        }}>
          <Button 
            variant="secondary" 
            onClick={handleClose}
            style={{
              padding: "8px 22px",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "500",
              backgroundColor: "#6c757d",
              borderColor: "#6c757d"
            }}
          >
            Close
          </Button>
          <Button 
            onClick={() => props.setConfirmUpdateCredit(true)}
            style={{
              padding: "8px 22px",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "500",
              color: "white",
              background: "linear-gradient(135deg, #4f6edb, #3b5ccc)",
              boxShadow: "0 8px 18px rgba(79,110,219,0.35)",
              transition: "all 0.2s",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 12px 22px rgba(79,110,219,0.45)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 8px 18px rgba(79,110,219,0.35)";
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default RenderAddCreditModal;
